import React from "react";
import HistoryRecord, { RideStatus } from "./history-record";

export default function History() {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="font-semibold text-2xl">History</h1>
        <div className="flex items-center space-x-2 cursor-pointer">
          <select
            name=""
            className="outline-none py-1 px-2 bg-border/20 rounded-[10px]"
            id=""
          >
            <option value="Completed">Completed</option>
            <option value="Ongoing">Ongoing</option>
            <option value="Scheduled">Scheduled</option>
            <option value="Canceled">Canceled</option>
          </select>
        </div>
      </div>
      <div>
        <div className="my-8">
          <HistoryRecord
            status={RideStatus.ongoing}
            time="22:43"
            fromLocation="Shomolu, Lagos"
            date="17th May"
            stops={[
              { location: "Bola Kemi, Kebbi State" },
              { location: "Bola Kemi, Enugu State" },
            ]}
          />
          <HistoryRecord
            status={RideStatus.canceled}
            time="22:43"
            fromLocation="Shomolu, Lagos"
            date="17th May"
            stops={[{ location: "Bola Kemi, Kebbi State" }]}
          />
          <HistoryRecord
            status={RideStatus.scheduled}
            time="22:43"
            fromLocation="Shomolu, Lagos"
            date="17th May"
            stops={[
              { location: "Bola Kemi, Kebbi State" },
              { location: "Bola Kemi, Enugu State" },
            ]}
          />
          <HistoryRecord
            status={RideStatus.completed}
            time="22:43"
            fromLocation="Shomolu, Lagos"
            date="17th May"
            stops={[{ location: "Bola Kemi, Enugu State" }]}
          />
        </div>
      </div>
    </div>
  );
}
